__webpack_require__.p = "/assets/turbo/670f9ca5/lascanach/_next/";